import Modal from "../../../../../../../components/Modal";
import Button from "../../../../../../../components/Button";
import Icon from "../../../../../../../components/Icon";
import { connect, useDispatch } from "react-redux";
import { Title, Text, SmallText, SuccessIcon, Continue, Cancel, Submit, Close, Actions, Flex } from "./styles";
import Snackbar from '../../../../../../../components/Snackbar'
import checkIcon from "../../../../../../../assets/icons/check-bold.svg";
import { initialValues, schema } from '../../../../../../../constants/forms/welcome-section/new'
// import Submit from "../../../../../../../components/FormikForm/Submit";
import { hideModal } from "../../../../../../../store/actions/modal";
import Form from '../Form'
import { CategoryDto } from "../../../../../../../types/category";
import { Center } from "../../../../../../../components/StyledComponents";
import { useEffect, useState } from "react";
import { newWelcomeContentSection, resetNewWelcomeContentSection } from "../../../../../../../store/actions/welcome-content";
import { Formik } from "formik";
import { WelcomeContentSectionDto } from "../../../../../../../types/welcome-section";
import { Group } from "../../../../../../../types";
import remove from "../../../../../../../assets/remove.svg";
import Image from "../../../../../../../components/Image";

interface ComponentProps {
  group: Group
  groupStates: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
  newWelcomeContentSectionCreated: WelcomeContentSectionDto;
  newWelcomeContentSectionCreatedStates: {
    success: boolean;
    loading: boolean;
    error: boolean | string;
  };
}

const Component = ({
  group,
  groupStates,
  newWelcomeContentSectionCreated,
  newWelcomeContentSectionCreatedStates,
}: ComponentProps) => {
  const dispatch = useDispatch();
  const [actions, setActions] = useState<{ resetForm: () => void }>()
  const [formSubmmited, setFormSubmmited] = useState(false);

  const onSubmit = ({ values, actions }) => {
    setActions(actions)
    dispatch(newWelcomeContentSection({ ...values, group_id: group?.id }));
  };

  const handleClose = () => {
    dispatch(hideModal())

    setTimeout(() => {
      dispatch(resetNewWelcomeContentSection());
    }, 1000)
  }

  useEffect(() => {
    if (newWelcomeContentSectionCreatedStates.success) {
      actions?.resetForm()
    }
  }, [newWelcomeContentSectionCreatedStates]);

  return (
    <>
      <Modal name="modal-new-welcome-section" width={newWelcomeContentSectionCreatedStates.success ? "350" : "550"} onClose={handleClose}>
        {newWelcomeContentSectionCreatedStates.success ? (
          <>
            <Flex>
              <SuccessIcon>
                <Icon icon={checkIcon} size="55px" color="#4CA154" />
              </SuccessIcon>
            </Flex>
            <div style={{ height: 28 }} />
            <Title>
              La sección de bienvenida se creó correctamente
            </Title>
            <div style={{ height: 8 }} />
            <Text>
              Ahora solo falta que crees los artículos que ayudarán a tus seguidores en sus primeros pasos por tu membresía.
            </Text>
            <div style={{ height: 28 }} />
            <Actions style={{ justifyContent: 'center' }}>
              <Close
                disabled={newWelcomeContentSectionCreatedStates.loading}
                options={{
                  type: "filled",
                  size: "lg",
                  skin: "purple",
                }}
                onClick={handleClose}
              >
                Cerrar
              </Close>
            </Actions>
            <div style={{ height: 8 }} />
          </>
        ) : (
          <>
            <Title>Bienvenida para nuevos suscriptores</Title>

            <div style={{ height: 22 }} />

            <Formik
              initialValues={{ ...initialValues }}
              onSubmit={(values, actions) => {
                if (onSubmit) onSubmit({ values, actions });
              }}
              validateOnChange={false}
              validateOnBlur={formSubmmited}
              validationSchema={schema}
              enableReinitialize
            >
              {({
                touched,
                errors,
                values,
                setFieldValue,
                handleChange,
                handleBlur,
                handleSubmit,
              }) => {
                return (
                  <form
                    className="theme-form"
                    onSubmit={(event) => {
                      setFormSubmmited(true);
                      handleSubmit(event);
                    }}
                    id="new-welcome-section"
                  >
                    <Form
                      touched={touched}
                      errors={errors}
                      values={values}
                      setFieldValue={setFieldValue}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                    />
                  </form>
                )
              }}
            </Formik>


            <Actions>
              <Cancel
                disabled={newWelcomeContentSectionCreatedStates.loading}
                options={{
                  type: "outline",
                  size: "lg",
                  skin: "black",
                }}
                onClick={handleClose}
              >
                Cancelar
              </Cancel>

              <Submit
                isSubmmiting={newWelcomeContentSectionCreatedStates.loading}
                options={{
                  type: "filled",
                  size: "lg",
                  skin: "purple",
                }}
                form="new-welcome-section"
              >
                Crear sección
              </Submit>
            </Actions>
          </>
        )}
      </Modal>
    </>
  );
};

const state = ({ groupStore, welcomeContentStore }) => {
  const { data: group, states: groupStates } = groupStore.group;
  const { data: newWelcomeContentSectionCreated, states: newWelcomeContentSectionCreatedStates } = welcomeContentStore.newWelcomeContentSection;

  return {
    group,
    groupStates,
    newWelcomeContentSectionCreated,
    newWelcomeContentSectionCreatedStates,
  };
};

export default connect(state)(Component);
